// T-151: stato condiviso minimale per il "fullscreen review" del carico
// DDT/fattura. La tab bar in basso deve restare visibile mentre l'utente sceglie
// la foto / lancia l'analisi (step capture), e sparire SOLO quando compare
// l'esito dell'analisi IA (fornitore + righe = step review), per dare al wizard
// tutta l'altezza. App.tsx (AppTabs) legge questo flag via useSyncExternalStore;
// CapturePhotoPage lo accende quando il dry_run è pronto e lo spegne all'uscita.

let active = false;
const listeners = new Set<() => void>();

export function setReviewFullscreen(value: boolean): void {
  if (value === active) return;
  active = value;
  for (const l of listeners) l();
}

export function getReviewFullscreen(): boolean {
  return active;
}

export function subscribeReviewFullscreen(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
